[
  {
    "code": "BW-CE",
    "name": "Central"
  },
  {
    "code": "BW-GH",
    "name": "Ghanzi"
  },
  {
    "code": "BW-KG",
    "name": "Kgalagadi"
  },
  {
    "code": "BW-KL",
    "name": "Kgatleng"
  },
  {
    "code": "BW-KW",
    "name": "Kweneng"
  },
  {
    "code": "BW-NE",
    "name": "North-East"
  },
  {
    "code": "BW-NW",
    "name": "North-West"
  },
  {
    "code": "BW-SE",
    "name": "South-East"
  },
  {
    "code": "BW-SO",
    "name": "Southern"
  }
]